import React, { useState } from 'react';
import {
  IconTrashLine,
  Spinner,
  IamProtected,
} from '@smarterservices/smarter-ui';
import { getStore } from '../../../../stores/StoreContext';
import { ButtonWithConfirmation } from '@ui/shared/components/Common/ButtonWithConfirmation';


const DeleteAnnotationButton = ({
  annotation,
  onDeleted
}) => {

  const [deleteInProgress, setDeleteInProgress] = useState(false);
  const ExamSessionStore = getStore('examSessionStore');
  const AppStore = getStore('appStore');
   
    const handleDelete = React.useCallback(async () => {
        setDeleteInProgress(true);
        // Implement delete functionality
        const result = await ExamSessionStore.deleteAnnotation(annotation.sid);
        if(result.success){
            onDeleted(result);
        }
        setDeleteInProgress(false);
    }, [ExamSessionStore, annotation.sid, onDeleted]);


  return (
    <IamProtected 
      action="sp:DeleteExamAnnotation" 
      resource={AppStore.getIamResourceString(`annotation/${annotation.sid}`)}
    >
      <ButtonWithConfirmation
        onConfirm={handleDelete}
        confirmationText="Delete this annotation?"
        confirmButtonText="Yes"
        cancelButtonText="No"
        confirmButtonColor="danger"
        color={deleteInProgress ? "secondary" : "danger"}
        screenReaderLabel="Delete Annotation"
      >
        {deleteInProgress ? <Spinner size="x-small" /> : <IconTrashLine />}
      </ButtonWithConfirmation>
    </IamProtected>
  );
};

export default DeleteAnnotationButton;
